import React, {ReactNode, useRef, useState} from "react";
import ExpandIcon from "../../icons/expand";

export default function HfUnmarked({name, value, onChange, placeholder, label, tips = null}: {
    name: string,
    value: string,
    onChange: (event: { target: { name: string, value: string } }) => void,
    placeholder: string,
    label: string,
    tips?: ReactNode
}) {
    // Expansion
    const [expanded, setExpanded] = useState(false);

    // Undo & Redo
    const [history, setHistory] = useState<string[]>([]);
    const [historyIndex, setHistoryIndex] = useState(-1);
    const [latestEditionTimestamp, setLatestEditionTimestamp] = useState(Date.now());

    const undo = () => {
        if (historyIndex > 0) {
            setHistoryIndex(historyIndex - 1);
            onChange({target: {name, value: history[historyIndex - 1]}});
        }
    };

    const redo = () => {
        if (historyIndex < history.length - 1) {
            setHistoryIndex(historyIndex + 1);
            onChange({target: {name, value: history[historyIndex + 1]}});
        }
    };

    const textareaRef = useRef<HTMLTextAreaElement | null>(null);

    const _onChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        event.preventDefault();
        onChange(event);

        if (Date.now() - latestEditionTimestamp < 5000) {
            setHistory([...history.slice(0, historyIndex), event.target.value]);
        } else {
            let s=0, e=historyIndex + 1;
            if (history.length > 5) {
                const dx = history.length - 5;
                s = dx;
                e=historyIndex - dx + 1;
            }

            setHistory([...history.slice(s, e), event.target.value]);
            setHistoryIndex(e);
        }

        setLatestEditionTimestamp(Date.now());
    }

    const _onKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
        // Allow tabulation
        if (event.key === "Tab") {
            event.preventDefault();
            if (!textareaRef.current) return;

            const {selectionStart, selectionEnd} = textareaRef.current;
            const newValue = value.substring(0, selectionStart) + "\t" + value.substring(selectionEnd);
            onChange({target: {name, value: newValue}} as any);
            setTimeout(() => {
                textareaRef.current!.selectionStart = selectionStart + 1;
                textareaRef.current!.selectionEnd = selectionStart + 1;
            });
        }

        // Allow Re-do / Un-do
        if ((event.ctrlKey || event.metaKey) && event.key === 'z') {
            event.preventDefault();
            if (event.shiftKey) {
                redo();
            } else {
                undo();
            }
        }
    }

    const _onBlur = (event: React.FocusEvent<HTMLTextAreaElement>) => {
        // textareaRef.current?.setSelectionRange(cursorPosition, cursorPosition);
    }

    return (
        <div className={"labeled-input " + (expanded ? "expanded" : "")}>
            <div className="label-group">
                <label htmlFor={name} className="label">{label}</label>
                <div className="tips">
                    {tips}
                    <div className="actions" onClick={() => setExpanded(!expanded)}>
                        <ExpandIcon/>
                    </div>
                </div>
            </div>

            <textarea ref={textareaRef} name={name} id={name} value={value} onChange={_onChange} onKeyDown={_onKeyDown}
                      onBlur={_onBlur} className="input"/>
        </div>
    );
}